import { InfoFieldGroupsType } from "./InfoFieldTypes";

export const UnitInfoFieldGroups: InfoFieldGroupsType = {
  general: {
    fields: {
      type: {
        type: "number",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      tenantType: {
        type: "string",
        defaultEnabled: false,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      orgNumber: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      floors: {
        type: "array",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      postAddress: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      area: {
        type: "number",
        suffix: "m²",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      parkingSpots: {
        type: "number",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      snr: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      apartmentNumber: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      streetNumber: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      fireSafetyResponsibles: {
        type: "array",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      contactInformation: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      contactEmail: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      contactPhone: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: true,
          entrepreneur: true,
        },
      },
      bedroomCount: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      furnitured: {
        type: "boolean",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: true,
      tenantAdmin: true,
      tenant: true,
      entrepreneur: true,
    },
  },
  finance: {
    fields: {
      incomeData: {
        type: "object",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      vatApplicable: {
        type: "number",
        suffix: "%",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      receivesEhfInvoice: {
        type: "boolean",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      contractConclusionDate: {
        type: "date",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      contractStartDate: {
        type: "date",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      contractEndDate: {
        type: "date",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      runningRenewal: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      optionDuration: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      optionDeadline: {
        type: "date",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      optionNotification: {
        type: "date",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      indexRegulation: {
        type: "object",
        suffix: "M",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      fixedRegulation: {
        type: "number",
        suffix: "M",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      regulationInterval: {
        type: "number",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      lastRegulation: {
        type: "date",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      jointArea: {
        type: "object",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      guarantee: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      waterRent: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      electricityRent: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
      accountNumber: {
        type: "string",
        visibility: {
          landlordAdmin: true,
          landlord: false,
          tenantAdmin: true,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: false,
      tenantAdmin: true,
      tenant: false,
      entrepreneur: false,
    },
  },
  landlordAdmin: {
    fields: {
      marketRent: {
        type: "number",
        suffix: ",-",
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: false,
      tenantAdmin: false,
      tenant: false,
      entrepreneur: false,
    },
  },
  note: {
    fields: {
      note: {
        type: "string",
        defaultEnabled: true,
        visibility: {
          landlordAdmin: true,
          landlord: true,
          tenantAdmin: false,
          tenant: false,
          entrepreneur: false,
        },
      },
    },
    visibility: {
      landlordAdmin: true,
      landlord: true,
      tenantAdmin: false,
      tenant: false,
      entrepreneur: false,
    },
  },
};

